.figure {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin: 0;
}

.image {
  display: block;
  width: 100%;
  height: auto;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg, 0.75rem);
}

.phone {
  align-self: center;
  width: min(100%, 18rem);
}

.caption {
  color: var(--color-muted);
  font-size: 0.875rem;
  text-align: center;
}
